import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _SlantPilotCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M7 6.661h2.44v4.881L14.018 21M16.458 21l-1.83-3.661-2.746-5.797V6.661h2.44M9.44 4.83h1.22m1.221 0h-1.22m0 0V3M9.745 15.509 7.915 21" })));
}
const SlantPilotCustom = forwardRef(_SlantPilotCustom);
export { SlantPilotCustom };
